import { BannerState, RootState } from "../types";
import { GetterTree, ActionTree, MutationTree, Module } from "vuex";
import { FETCH_BANNER_DATA } from "./actions.names";
import { API_URL } from "../global";
import axios from "axios";
import { SET_BANNER_DATA, SET_BANNER_DATA_ERROR } from "./mutations.names";
import Vue from "vue";

export const state: BannerState = {
  data: [],
  error: false,
};

const namespaced: boolean = false;

const getters: GetterTree<BannerState, RootState> = {
  bannerData(state) {
    // if (!state) {
    //   return undefined;
    // }
    return state.data;
  }
};


const actions: ActionTree<BannerState, RootState> = {
  async [FETCH_BANNER_DATA]({ commit }, id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
      .get(`${API_URL}/pages/${id}`)
      .then(({ data }) => {
        commit(SET_BANNER_DATA, data);
        resolve()
      })
      .catch((err) => {
        commit(SET_BANNER_DATA_ERROR);
        reject()
      });
    })
    
  },
};


const mutations: MutationTree<BannerState> = {
  [SET_BANNER_DATA](state, payload): any {
    //console.log(payload);
    Vue.set(state, 'data', payload);
    // state.data = payload;
    state.error = false;
   // console.log(state);
  },
  [SET_BANNER_DATA_ERROR](state: any): any {
    state.data = [];
    state.error = true;
  }
};

export const bannerData: Module<BannerState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
